import type { RouterOutputs } from "@/trpc";

// Ticket rows as served to the board — the ServiceRequest entity plus the
// lead enrichment applied in logic/ticket.ts.
export type SolicitudTicket =
  RouterOutputs["serviceRequests"]["listByStatus"]["data"][number];

// Ticket positions arrive grouped by stage from pipeline.getTicketPositions;
// the board flattens them into one ordered rail.
export type TicketPosition = {
  id: string;
  stage: string;
  status: string;
  order: number;
  displayName: string;
  isSystem: boolean;
};

// Only the filters the ticket store can actually serve. Date range lives in
// the container's shared dateRange (it's an index key condition, not a filter
// expression, so it doesn't force filter mode).
export type SolicitudFiltros = {
  categoria: string | null;
  asesor: string | null;
  prioridad: string | null;
};

export const EMPTY_SOLICITUD_FILTROS: SolicitudFiltros = {
  categoria: null,
  asesor: null,
  prioridad: null,
};

// Category / asesor / prioridad are DynamoDB filter expressions, so they can't
// drive the per-status index queries — setting any of them switches the board
// to a single listFiltered query grouped client-side.
export const isSolicitudFilterMode = (f: SolicitudFiltros): boolean =>
  !!(f.categoria || f.asesor || f.prioridad);
